import { render, staticRenderFns } from "./LoadingOverlayFullscreen.vue?vue&type=template&id=2e68401f&scoped=true"
import script from "./LoadingOverlayFullscreen.vue?vue&type=script&lang=js"
export * from "./LoadingOverlayFullscreen.vue?vue&type=script&lang=js"
import style0 from "./LoadingOverlayFullscreen.vue?vue&type=style&index=0&id=2e68401f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68401f",
  null
  
)

export default component.exports